import { render, staticRenderFns } from "./addEmailcopy.vue?vue&type=template&id=73858782&scoped=true&"
import script from "./addEmailcopy.vue?vue&type=script&lang=js&"
export * from "./addEmailcopy.vue?vue&type=script&lang=js&"
import style0 from "./addEmailcopy.vue?vue&type=style&index=0&id=73858782&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73858782",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73858782')) {
      api.createRecord('73858782', component.options)
    } else {
      api.reload('73858782', component.options)
    }
    module.hot.accept("./addEmailcopy.vue?vue&type=template&id=73858782&scoped=true&", function () {
      api.rerender('73858782', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmTool/email/components/addEmailcopy.vue"
export default component.exports